import * as React from "react";
import {cs} from "../../../../../react/chain-services";
import "./badge.scss";
import {cx} from "emotion";

export const Badge = ({color, icon=undefined, text=undefined, message=undefined, xdQaName=undefined}) => cs(
    () => (
        <div {...{
            className: cx("badge badge-074", color, {"with-icon": !!icon}),
            "xd-qa-type": "icon",
            "xd-qa-name": xdQaName ?? message,
        }}>
            {icon && (
                <i className={icon}/>
            )}
            {text ?? message}
        </div>
    ),
);